import React, { Component } from "react";
import Accounting_accountForm from "../Accounting_accountForm/Accounting_accountForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingPage
Description : Componente que contienen el formulario de la pantalla Accounting 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente AccountingForm
================================================================================ */
class Accounting_accountPage extends Component{
    render(){
        return(
            <div>                    
                <Accounting_accountForm/>
            </div>
        )   
    }
}

export default Accounting_accountPage;